import * as React from 'react';
import MenuItems from './MenuItems';
import { menuItems } from './define';

type MainListItemsProps = {
  menuFull: boolean;
};

const MainListItems: React.FC<MainListItemsProps> = (props) => {
  return (
    <>
      {menuItems.map((item, index) => {
        return <MenuItems key={index} items={item} menuFull={props.menuFull} />;
      })}
    </>
  );
};

export default MainListItems;
